import { render, staticRenderFns } from "./AddInsuranceForm.vue?vue&type=template&id=0e13272e&"
import script from "./AddInsuranceForm.vue?vue&type=script&lang=js&"
export * from "./AddInsuranceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports